module.exports = __webpack_public_path__ + "img/p60-collage.1d397543.jpg";